import React from 'react'

import FreeTrialBanner from './free_trial_banner.jsx'
import FreeTrialStatus from './free_trial_status.jsx'
import NewSignUpBanner from './new_signup_banner.jsx'

import { requestGet, } from '../../../../../modules/request'

export default class PremiumBannerBuilder extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      has_premium: null,
      trial_days_remaining: null,
      first_day_of_premium_or_trial: null
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    requestGet('/teachers/classrooms/premium', (data) => {
      this.setState({
        last_subscription_was_trial: data.last_subscription_was_trial,
        has_premium: data['hasPremium'],
        trial_days_remaining: data['trial_days_remaining'],
        first_day_of_premium_or_trial: data['first_day_of_premium_or_trial']
      })
    })
  };

  stateSpecificComponents = () => {
    const { has_premium, first_day_of_premium_or_trial, trial_days_remaining, last_subscription_was_trial, } = this.state

    const { originPage, upgradeToPremiumNow } = this.props
    if (has_premium === 'none'){
      return(<FreeTrialBanner status={has_premium} />);
    }
    else if (first_day_of_premium_or_trial ){
      return(<NewSignUpBanner status={has_premium} />);
    }
    else if ((has_premium === 'trial') || (has_premium === 'locked')){
      return(
        <span>
          <FreeTrialStatus
            data={trial_days_remaining}
            lastSubscriptionWasTrial={last_subscription_was_trial}
            originPage={originPage}
            status={has_premium}
            upgradeToPremiumNow={upgradeToPremiumNow}
          />
        </span>
      );
    }
    else if ((has_premium === 'school') || ((has_premium === 'paid') && (first_day_of_premium_or_trial === false))) {
      return (<span />);
    }
  };

  hasPremium = () => {
    const { has_premium, first_day_of_premium_or_trial, } = this.state
    if ((has_premium === null) || (has_premium === 'school') || ((has_premium === 'paid') && (first_day_of_premium_or_trial === false))) {
      return (<span />);
    } else
    {
      return (
        <div>
          <div id='premium-banner'>
            <div className='container'>
              {this.stateSpecificComponents()}
            </div>
          </div>
        </div>
      );
    }
  };

  render() {
    return (this.hasPremium());

  }
}
